import CryptoJS from 'crypto-js'
import { ClientUrlParam } from './types'

/**
 * 解析 URL 中的 _cl 参数
 * 支持从顶层 URL 或嵌套的 s_url (回调地址) 中提取
 * @param searchParams URLSearchParams 对象或查询字符串
 */
export function parseClientParam(searchParams: URLSearchParams | string): ClientUrlParam | null {
  const params = typeof searchParams === 'string' ? new URLSearchParams(searchParams) : searchParams

  // 1. 尝试直接获取
  let clValue = params.get('_cl')

  // 2. 如果顶层没有，尝试从 s_url 中提取
  if (!clValue) {
    const sUrl = params.get('s_url')
    if (sUrl) {
      try {
        // 解码 s_url 并尝试解析
        // 注意：s_url 可能只是一个相对路径或不完整的 URL，但在 searchParams 中通常是编码过的
        // 我们尝试将其构建为一个 URL 对象来解析参数
        // 如果 s_url 不是绝对路径，new URL(sUrl) 会报错，所以给一个 base
        const nestedUrl = new URL(sUrl)
        clValue = nestedUrl.searchParams.get('_cl')
      } catch (e) {
        // s_url 解析失败，忽略
        // console.debug('Failed to parse s_url:', e)
      }
    }
  }

  if (!clValue) {
    return null
  }

  try {
    // 1. Base64 解码 (使用 CryptoJS 以更好地支持中文/多字节字符)
    const words = CryptoJS.enc.Base64.parse(clValue)
    const decoded = CryptoJS.enc.Utf8.stringify(words)

    // 2. 处理可能的外层单引号包裹
    // 示例：'{ "t": ... }' -> { "t": ... }
    let jsonString = decoded.trim()
    if (jsonString.startsWith("'") && jsonString.endsWith("'")) {
      jsonString = jsonString.slice(1, -1)
    }

    // 3. JSON 解析
    try {
      return JSON.parse(jsonString) as ClientUrlParam
    } catch (e) {
      // 如果标准解析失败，尝试处理单引号情况（非标准 JSON 兼容）
      try {
        // 将单引号替换为双引号。注意：这在 UA 包含单引号时可能存在风险，
        // 但对于目前已知的结构 {'t':...} 是一种有效的容错手段。
        const fixedJson = jsonString.replace(/'/g, '"')
        return JSON.parse(fixedJson) as ClientUrlParam
      } catch (secondError) {
        // 如果还是失败，则抛出原始错误
        throw e
      }
    }
  } catch (e) {
    console.error('[FastLoginSDK] Failed to parse _cl param:', e)
    return null
  }
}
